import * as insuredPersonActions from './actions';

import {
  DetailsInsuredPersonActionTypes,
  DetailsInsuredPersonState,
} from './types';

import { ActionType } from 'typesafe-actions';
import { Reducer } from 'redux';

export type InsuredPersonAction = ActionType<typeof insuredPersonActions>;

const initialState: DetailsInsuredPersonState = {
  id: 0,
  firstName: '',
  lastName: '',
  companyName: '',
  occupancy: '',
  companyNumber: '',
  clientType: '',
  street: '',
  buildingNumber: '',
  busNumber: '',
  zipCode: '',
  city: '',
  country: '',
  accountNumber: '',
  iban: '',
  bic: '',
  telephone: '',
  telephoneWork: '',
  mobile: '',
  fax: '',
  email: '',
  language: '',
  languageTC: '',
  languageTypeList: [],
  instructionId: 0,
};

const reducer: Reducer<DetailsInsuredPersonState, InsuredPersonAction> = (
  state = initialState,
  action
): DetailsInsuredPersonState => {
  switch (action.type) {
    case DetailsInsuredPersonActionTypes.FETCH_INSURED_PERSON_SUCCESS: {
      return { ...state, ...action.payload };
    }
    case DetailsInsuredPersonActionTypes.RESET_STATE: {
      return initialState;
    }
    case DetailsInsuredPersonActionTypes.UPDATE_LANGUAGE_INSURED_PERSON: {
      return { ...state, instructionId: action.payload.instructionId, languageTC: action.payload.languageTC };
    }
    case DetailsInsuredPersonActionTypes.UPDATE_LANGUAGE_INSURED_PERSON_FAILED: {
      return { ...state };
    }
    case DetailsInsuredPersonActionTypes.UPDATE_LANGUAGE_INSURED_PERSON_SUCCESS: {
      return { ...state };
    }
    case DetailsInsuredPersonActionTypes.FETCH_INSURED_PERSON_FAIL:
    default: {
      return state;
    }
  }
};

export {
  reducer as detailsInsuredPersonReducer,
  initialState as detailsInsuredPersonInitialState,
};
